<template>
  <EditCom
    title="分配用户"
    :target="editTarget"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  />
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';

import EditCom from '@/components/EditCom';

import { queryOrdinaryUserList, } from '@/api/System/UserManager';
import { geoserverMapToUser, } from '@/api/MapManage';

// props
const props = defineProps({
  target: { type: Object, },
});
// emit
const emit = defineEmits([
  'close', 'submitCallback',
]);

const close = ()=>{
  emit('close')
}

const submitFn = (item, button, loadFn, fn)=>{
  // console.log(item, button, loadFn, fn);
  geoserverMapToUser({
    ...item,
    tileEffectiveTime: item.tileEffectiveTime?dayjs(item.tileEffectiveTime).format('YYYY-MM-DD HH:mm:ss'):undefined,
  }).then(res=>{
    if(res.data.code == 1004){
      emit('close');
      emit('submitCallback');
    }
    loadFn();
  }).catch(err=>{
    loadFn();
    console.log(err);
  });
}

const submit = (form, item, button, loadFn, fn)=>{
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn();
    }
  });
}

const editTarget = reactive({
  ...props.target,
  userList: [
    { userId: 0, userName: '所有' },
  ],
})

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]),
inputList = ref([
  { name: '用户', prop: 'polygonUserList', type: 'select',
    select: {
      list: 'userList',
      value: 'userId',
      label: 'userName',
      multiple: true,
      filterable: true,
    }
  },
  { name: '有效期', prop: 'tileEffectiveTime', type: 'datetime',
    date: {}
  }
]),
rules = reactive({
  
})
const queryOrdinaryUserListFn = ()=>{
  queryOrdinaryUserList({}).then(res=>{
    if(res.data.code == 1004){
      editTarget['userList'].push(...res.data.dataList);
    }
  }).catch(err=>{
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  queryOrdinaryUserListFn();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>